module.exports = __webpack_public_path__ + "static/media/startpage2025_1366.53961840.png";